import { Component, Input, Output, OnInit } from '@angular/core';

import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-codigo-pais-popover',
  templateUrl: './codigo-pais-popover.component.html',
  styleUrls: ['./codigo-pais-popover.component.scss'],
})
export class CodigoPaisPopoverComponent implements OnInit {

  @Input() countryCode: any[] = [];

  @Output() option;

  constructor(private popoverController: PopoverController) { }

  ngOnInit() { }

  closePopover() {
    this.popoverController.dismiss();
  }

  getOption(countryCode) {
    console.log('Opción elegida(lado del hijo):', countryCode.code, countryCode.pais);
    this.option = { codigo: countryCode.code, pais: countryCode.pais };
    this.popoverController.dismiss(this.option);
  }

}
